import { Spinner } from "react-bootstrap";


export function WaitingOverlay() {
    return (
        <Spinner animation="border" role="status">

        </Spinner>
    );
}